export default "__VITE_ASSET__4a8a99bd__"